import React from 'react';
import Modal from 'react-modal';
import Row from '../../../../components/tag/Row';
import OTButtonGroup from '../../../../components/tag/OTButtonGroup';
import OTButton from '../../../../components/tag/OTButton';
import modal from '../../../../definitions/Modal';
import { FormattedMessage } from 'react-intl';

const notificationModal = modal({ content: { width: '500px' } });

const GTIBeginModal = (props) => {
  let { hideModal, goToGTI, gtiFetching, ...rest } = props;

  return (
    <Modal {...rest} style={notificationModal}>
      <Row>
        <p>
          <FormattedMessage id="gti.confirm.navigation" />
        </p>
      </Row>
      <Row>
        <OTButtonGroup type="big" fullWidth={true}>
          <OTButton key="cancel" onClick={hideModal}>
            <FormattedMessage id="cancel" />
          </OTButton>
          {!gtiFetching && (
            <OTButton key="submit" onClick={goToGTI}>
              <FormattedMessage id="continue" />
            </OTButton>
          )}
        </OTButtonGroup>
      </Row>
    </Modal>
  );
};

export default GTIBeginModal;
